import { create } from 'zustand'
import { I18nLabel } from '@/core/types/graphql'

export const store = create(() => ({ map: new Map<string, string>() }))

export const initialize = (array: I18nLabel[]) => {
  store.setState({
    map: new Map<string, string>(
      (array ?? []).map(({ key, value }) => [key, value])
    )
  })
}

export const getLabel = (key: string) => store.getState().map.get(key)
